<template>
  <div>
    <b-form-group
      id="input-group-1"
      label="Categoria:"
      
    >
      <b-form-select 
        v-model="ticketData.categoria" 
        :options="ticketData.categorias"
      >
      </b-form-select>  
    </b-form-group>

    <b-form-group 
      v-if = "ticketData.categoria != '1'"
      id="input-group-2"
      label="Titulo:"
      label-for="titulo"  
    >
      <b-form-input
        id="titulo"
        v-model="ticketData.titulo"
        name="titulo"
        v-validate="'min:2 '" 
        :state="$parent.validateState('titulo')"
        placeholder="Titulo del reporte"
      ></b-form-input>

      <b-form-invalid-feedback>
        {{  errors.first('titulo') }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      v-else
      id="input-group-4"
      label="Maquina:"
    >
      <select @change="onChange($event)" class="form-control" v-model="ticketData.maquina">
        <option v-for="option in ticketData.maquinas" v-bind:value="option.value" >{{ option.text }}</option>
      </select>
    </b-form-group>

    <b-form-group
      id="input-group-3"
      label="Descripción:"
      label-for="descripcion"
    >
      <b-form-textarea
      id="descripcion"
      v-model="ticketData.descripcion"
      placeholder="Introduzca la descripción del ticket"
      rows="3"
      max-rows="6"
      v-validate="'required|min:3'" 
      :state="$parent.validateState('descripcion')"
      >
      </b-form-textarea>

      <b-form-invalid-feedback>
        {{  errors.first('descripcion') }}
      </b-form-invalid-feedback>

    </b-form-group>

  </div>
</template>

<script>
  import customMixin from '@/mixins/customMixin'
  export default {
    //para que el padre inyecte el validador a este componente hijo. 
    inject:['$validator'],
    // data que viene del padre
    props:{
        ticketData:{
          type: Object,
          required:true
        }
      },
    mixins : [customMixin],
    
    data:function () {
      return{
       
      }
    },

    methods:{
      onChange(e){
        
        this.ticketData.titulo = this.selectText(e)
      },
    },
    
  }
</script>

<style lang="scss" scoped>

</style>